import context, { Constants } from '@truckdown/systems';
import { defineComponent, ref, Ref, computed, onMounted, watch } from 'vue';
import { BannerModel, BannerStatus } from '@truckdown/locations';

interface IDisplayBanner {
    id: string;
    status: string;
    type: string;
    accountId: string;
    imageId: string;
    websiteAddress: string;
    location: string;
    services: string;
}

interface IProps {
    banners: BannerModel[];
}

interface IData {

}

const getData = function (props: IProps): IData {
    return {
    };
}

const getComputed = function (props: IProps, data: IData) {
    return {
        displayBanners: computed(() => {
            return props.banners.map(b => {
                return {
                    id: b.id,
                    status: 'status',
                    type: 'type',
                    accountId: b.accountId,
                    imageId: b.imageId,
                    websiteAddress: b.websiteAddress,
                    location: 'location',
                    services: 'services'
                } as IDisplayBanner;
            });
        })
    }
}

const getMethods = function (props: IProps, data: IData, ctx: any) {
    return {
    }
}

const events = {
}

export default defineComponent({
    name: "banner-list",
    emits: [],
    components: {
    },
    props: {
        banners: {
            type: Array as () => BannerModel[],
            required: true
        }
    },
    setup: function (props, ctx) {
        let data = getData(props);
        let computed = getComputed(props, data);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});